import { render, staticRenderFns } from "./SupportTabs.vue?vue&type=template&id=3fd7ff74&scoped=true&"
import script from "./SupportTabs.vue?vue&type=script&lang=js&"
export * from "./SupportTabs.vue?vue&type=script&lang=js&"
import style0 from "./SupportTabs.vue?vue&type=style&index=0&id=3fd7ff74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd7ff74",
  null
  
)

export default component.exports